'use client';

import type { ProgramFile } from '@/modules/Entertainment/interface/Program';
import { useMemo, useState, type FC } from 'react';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { IfRender } from '@/utils/jsx';
import { SupplementaryMaterialCard } from './Card';

export const SupplementaryMaterials: FC<SupplementaryMaterialsProps> = ({
  files,
}) => {
  const t = useT();

  const [quantity, setQuantity] = useState(4);

  const slicedFiles = useMemo(
    () => files.slice(0, quantity),
    [files, quantity]
  );

  const showMoreContent = () => {
    setQuantity((prev) => {
      const newQuantity = prev + 4;
      if (newQuantity > files.length) {
        return files.length;
      }
      return newQuantity;
    });
  };

  if (files.length === 0) {
    return <></>;
  }

  return (
    <Flex id="material-complementar" flexDir="column" gap="l">
      <Text size="h6" fontWeight="normal">
        {t('screens.researchProgram.supplementary.title')}
      </Text>
      <Flex flexWrap="wrap" gap="m">
        {slicedFiles.map(({ id, ...rest }) => (
          <SupplementaryMaterialCard key={id} {...rest} />
        ))}
      </Flex>
      <IfRender condition={quantity < files.length}>
        <Button
          onClick={showMoreContent}
          alignSelf="center"
          color="content.brand"
          variant="naked"
          fontSize="m"
          fontWeight="semibold"
        >
          {t('attributes.loadMore')}
        </Button>
      </IfRender>
    </Flex>
  );
};

type SupplementaryMaterialsProps = {
  files: ProgramFile[];
};
